import React from 'react';
import { cn } from '../../../lib/utils';

interface SectionRatingProps {
  score: number | string;
}

export const SectionRating: React.FC<SectionRatingProps> = ({ score }) => {
  const numericScore = typeof score === 'string' ? parseFloat(score) : score;
  
  return (
    <div className={cn(
      "px-2 py-0.5 rounded text-sm font-medium",
      numericScore >= 7 ? "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-100" :
      numericScore >= 4 ? "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-100" :
      "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-100"
    )}>
      {typeof score === 'object' 
        ? JSON.stringify(score) 
        : typeof score === 'number' && score % 1 === 0 
          ? score.toFixed(0) 
          : typeof score === 'number' 
            ? score.toFixed(1) 
            : score}
    </div>
  );
};